import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common/typings';
import { getExperimentTestId, useGeneratePath, useMe, useStaticUrls } from 'platform-components';
import { useStableCallback } from 'platform-components/src/utils/hooks';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router';
import ym from 'react-yandex-metrika';

import { getCurrentTeamLevel } from 'common.components/user/selectors';
import { getSubjectLibraryTabs } from 'store/subject-config/selectors';

import LibraryTabsView from '../__tabs-view/library__tabs-view';
import { getCurrentShowcaseSlug, getCurrentSubjectPageSlug } from '../../library.store/selectors';

const LibraryTabs = () => {
    const { labClassLibrarySubjectTab, labLibrarySubjectPromo, labLibrarySubjectCollection } = useStaticUrls();
    const { tabSlug } = useRouteMatch<{ tabSlug?: SUBJECT_LIBRARY_TAB_SLUG }>(labClassLibrarySubjectTab)?.params || {};
    const isPromoPath = useRouteMatch(labLibrarySubjectPromo);
    const isContainersPath = useRouteMatch(labLibrarySubjectCollection);
    const currentTab = useMemo((): SUBJECT_LIBRARY_TAB_SLUG => {
        if (isPromoPath) {
            return SUBJECT_LIBRARY_TAB_SLUG.TIMELINE;
        }
        if (isContainersPath) {
            return SUBJECT_LIBRARY_TAB_SLUG.CONTAINER;
        }
        return tabSlug || SUBJECT_LIBRARY_TAB_SLUG.MAIN;
    }, [isContainersPath, isPromoPath, tabSlug]);
    const { classId: classIdFromMatch, subject } = useParams<Record<string, string>>();
    const classId = Number(classIdFromMatch);
    const grade = useSelector((state) => getCurrentTeamLevel(state, { classId }));
    const reachGoal = useMetrikaReachGoal(subject, classId, grade);
    const tabs = useSelector((state) => getSubjectLibraryTabs(state, { subject, grade }));
    const history = useHistory();
    const getRouterPath = useGeneratePath();
    const handleClick = useStableCallback((slug: string) => {
        reachGoal(slug);
        history.push(getRouterPath(labClassLibrarySubjectTab, { tabSlug: slug }) + history.location.search);
    });
    if (tabs.length === 0) {
        return null;
    }
    return <LibraryTabsView currentTab={currentTab} onTabClick={handleClick} tabs={tabs} />;
};

const useMetrikaReachGoal = (subject: string, classId: number, grade: number | null) => {
    const me = useMe();
    const testId = useSelector(getExperimentTestId);
    const currentShowcaseSlug = useSelector(getCurrentShowcaseSlug);
    const currentSubjectPageSlug = useSelector((state) =>
        // @ts-ignore
        getCurrentSubjectPageSlug(state, { subject, classId, grade })
    );
    return (slug: string) => {
        const goal =
            slug === SUBJECT_LIBRARY_TAB_SLUG.MAIN
                ? 'teacher_library_chose_rubricator'
                : 'teacher_library_chose_vitrina';
        ym('reachGoal', goal, {
            teacher_id: me?.id || null,
            subject_slug: subject,
            team_level: grade,
            test_id: testId,
            general_showcase_slug: currentShowcaseSlug,
            subject_page_showcase_slug: currentSubjectPageSlug,
        });
    };
};

export default React.memo(LibraryTabs);
